// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3SQqK","errorLogs":"styles_errorLogs__3SHRU"};